<template>
  <ls-table-layout>
    <template #search>
      <unsatisfactory-detail-search-form @search="onSearch" ref="unsatisfactorySearch"/>
    </template>
    <template #btn>
      <a-button v-hasPermi="['unsatisfactoryReceivingDetail:export']" @click="onExport">导出</a-button>
    </template>
    <template #table>
      <ls-api-table
        ref="dataTable"
        class="ls-table-footer-summary"
        :columns="columns"
        :tableProps="tableProps"
        :scroll="{ x: 1200, fixScreen: true,extraHeight: 80}"
        :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.UNSATISFACTORY_RECEIVING_DETAIL_LIST, // 表格方案配置唯一值
              }"
      >
        <template #curOrderSatisfyRate="{text}">
          {{ percentSecondNum(text) }}
        </template>
        <template #beforeSumOrderSatisfyRate="{text}">
          {{ percentSecondNum(text) }}
        </template>
        <template #sumOrderSatisfyRate="{text}">
          {{ percentSecondNum(text) }}
        </template>
        <template #beforeLocationUseRate="{text}">
          {{ percentNum(text) }}
        </template>
        <template #locationUseRate="{text}">
          {{ percentNum(text) }}
        </template>
        <template #loadAddIs="{text}">
          {{ ['非增减货','增货','减货'][text] }}
        </template>
        <template #status="{text}">
          {{ STATUS_MAP[text] }}
        </template>
        <template #completeStatus="{text}">
          {{ COMPLETE_STATUS_MAP[text] }}
        </template>
        <template #supplierExclusiveIs="{text}">
          {{ ['否','是'][text] }}
        </template>

        <template v-for="item in ['beforeTotalVolume','totalVolume']" #[item]="{text}" >
          <span :key="item">{{ formatNum(text,2) }}</span>
        </template>
        <template #footer>
          <a-table
            bordered
            :showHeader="false"
            class="footerTable"
            :columns="summaryColumns"
            :data-source="sumInfoList"
            :pagination="false"
          >
            <template v-for="item in ['beforeTotalVolume','totalVolume']" #[item]="text" >
              <span :key="item">{{ formatNum(text,2) }}</span>
            </template>
          </a-table>
        </template>
      </ls-api-table>
    </template>
  </ls-table-layout>
</template>
<script>
// import UnsatisfactoryListSearchForm from '@/views/mes/scheduling-plan/unsatisfactory-receiving/components/unsatisfactory-list-search-form.vue'
import {
  COLUMNS_DETAIL,
  COMPLETE_STATUS_MAP,
  STATUS_MAP
} from '@/views/mes/scheduling-plan/unsatisfactory-receiving/enum'
import {
  apiExportReceiptPlanUnsatisfiedReport,
  apiReceiptPlanUnsatisfiedReport, apiReceiptPlanUnsatisfiedReportSum
} from '@/api/mes/scheduling-plan/unsatisfactory-receiving'
import { generateLsTableResData } from '@/utils/util'
import UnsatisfactoryDetailSearchForm
  from '@/views/mes/scheduling-plan/unsatisfactory-receiving/components/unsatisfactory-detail-search-form.vue'
import { fixedTable } from 'lsmy-libs'
import { formatNum } from '@/utils/fomatteNum'
export default {
  mixins: [fixedTable],
  // 不满足收货报表
  // eslint-disable-next-line
  name: 'Unsatisfactory-receiving-detail', // name要和rms配置菜单路由保存一致(首字母大写)
  computed: {
    COMPLETE_STATUS_MAP() {
      return COMPLETE_STATUS_MAP
    },
    STATUS_MAP() {
      return STATUS_MAP
    },

    summaryColumns() {
      const columns = JSON.parse(JSON.stringify(this.columns))
      columns.splice(0, 1, {
        title: '序号',
        width: 70
      })
      return columns
    },
    columns() {
      return this.stickyFixedColumns(COLUMNS_DETAIL)
    }
  },
  components: { UnsatisfactoryDetailSearchForm },
  data () {
    return {
      tableProps: {
        requestApi: generateLsTableResData(apiReceiptPlanUnsatisfiedReport, false)
      },
      sumInfoList: [{}]
    }
  },
  methods: {
    formatNum,
    // 搜索
    onSearch(val = {}) {
      this.$refs.dataTable.searchParams = val
      this.$refs.dataTable.getData()
      apiReceiptPlanUnsatisfiedReportSum(val).then(res => {
        this.sumInfoList = res.data ? [res.data] : [{}]
      })
    },
    // 导出
    onExport() {
      const formData = this.$refs.dataTable.searchParams
      apiExportReceiptPlanUnsatisfiedReport(formData)
    },
    // 合并表格设置同步滚动
    setScroll () {
      // 同步表与footer滚动
      const dom = this.$refs.dataTable.$el.querySelectorAll('.ant-table-body')[0]
      dom.addEventListener('scroll', () => {
        this.$refs.dataTable.$el.querySelectorAll('.ant-table-body')[1].scrollLeft = dom.scrollLeft
      }, true)
    },
    // 格式化金额
    percentNum (val) {
      if (!val) {
        return val
      }
      const value = Math.floor(Number(val) * 10000) / 100
      return value + '%'
    },
    percentSecondNum(val) {
      if (!val) {
        return val
      }
      const value = Math.floor(Number(val) * 100)
      return value + '%'
    },
    getRouterValue() {
     if(this.$route.query && this.$route.query.factoryCode) {
       this.onSearch({
         factoryCode: this.$route.query.factoryCode,
         requireDeliveryDay: this.$moment().startOf('day').add('1', 'days').format('YYYY-MM-DD')
       })
       this.$refs.unsatisfactorySearch.setFormValue({
         factoryCode: this.$route.query.factoryCode,
         requireDeliveryDay: this.$moment().startOf('day').add('1', 'days').format('YYYY-MM-DD')
       })
     }else{
       this.onSearch({
         requireDeliveryDay: this.$moment().startOf('day').add('1', 'days').format('YYYY-MM-DD')
       })
     }
     this.$refs.unsatisfactorySearch.setFormValue({
       requireDeliveryDayValue: this.$moment().startOf('day').add('1', 'days')
     })
    }
  },
  mounted() {
    this.setScroll()
  },
  activated() {
    this.getRouterValue()
  }
}
</script>
<style lang="less" scoped>
.ls-table-footer-summary{
  /deep/ .ant-table-footer {
    padding: 0;
    border: 0;
  }
}
::v-deep .ant-table-thead > tr > th, ::v-deep .ant-table-tbody > tr > td {
  padding: 4px;
}
.footerTable {
  ::v-deep .ant-table-thead > tr > th, ::v-deep .ant-table-tbody > tr > td {
    padding: 4px;
  }
  ::v-deep .ant-table-body{
    overflow-x: hidden !important;
    margin: 0 !important;
    overflow-y: scroll;
  }
}
</style>
